const NotFound: React.FC = () => {
  return (
    <div style={{ textAlign: "center" }}>
      <h1>404 Error</h1>
      <h4>Sorry Page is Not Found</h4>
      <p>
        Please go <a href="/">home</a>
      </p>
    </div>
  );
};

export default NotFound;
